import React, { Component } from 'react';
import { Grid, } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import useStyles from './mobileStyles';
import { createRefetchContainer, graphql, QueryRenderer, requestSubscription } from 'react-relay';
import { Doughnut, Bar } from 'react-chartjs-2';
import environment from '../../environment';
import WMMobileLeadContainer from './WMMobileLeadContainer';
var moment = require('moment-timezone');

const colors = [
    'rgba(236, 170, 31, 1)',
    'rgba(190, 214, 0, 1)',
    'rgba(255, 255, 255, 1)'
];

class WMMobileTop extends Component {
    constructor(props){
        super(props);
        this.state = {
            current_bid: 5,
            current_pool: 0,
            current_group_number: 1,
            last_group: {},
            next_groups: [],
            user: {},
            total_graph_data: {},
        }

        this.loadGraphs = this.loadGraphs.bind(this);
    }

    componentDidMount(){
        const { getLonewolfPersonalData, event_id, quarter_id, chapters, guest_token } = this.props;
        if(getLonewolfPersonalData.getLonewolfPersonalData){
            const data = getLonewolfPersonalData.getLonewolfPersonalData.data;
            let total_labels = [];
            let total_datasets = [];
            let total_graph_data = {};
            let user_datasets = [];

            if(quarter_id == -1){
                let quarter = 1;
                let group_number = 1;
                let temp = 0;
                let user_temp = 0;

                data.winnings_by_group.forEach((group, i) => {
                    if(group.group_number < group_number){
                        let current_chapter = chapters.filter(ch => ch.quarter_number == quarter)[0];
                        let chapter_name = current_chapter ? current_chapter.quarter_name : '';
                        total_labels.push(chapter_name);
                        total_datasets.push(temp);
                        user_datasets.push(user_temp);
                        quarter += 1;
                        group_number = 1;
                        temp = 0;
                        user_temp = 0;
                    } else {
                        group_number = group.group_number;
                        if(group.money){
                            temp += parseInt(group.money);
                            if(group.user_won) user_temp += parseInt(group.money);
                        }
                    }
                    if(i == data.winnings_by_group.length - 1){
                        let current_chapter = chapters.filter(ch => ch.quarter_number == quarter)[0];
                        let chapter_name = current_chapter ? current_chapter.quarter_name : '';
                        total_labels.push(chapter_name);
                        total_datasets.push(temp);
                        user_datasets.push(user_temp);
                    }
                });
                while(quarter < chapters.length){
                    const ch = chapters[quarter];
                    if(ch.quarter_number != -1){
                        total_labels.push(ch.quarter_name);
                        total_datasets.push(0);
                        user_datasets.push(0);
                    }
                    quarter += 1;
                }

                let dataArray = [{
                    data: total_datasets,
                    backgroundColor: 'rgb(255,255,255)',
                }];
                if(guest_token) dataArray.unshift({
                    data: user_datasets,
                    backgroundColor: 'rgb(190,214,0)',
                });

                total_graph_data = {
                    labels: total_labels,
                    datasets: dataArray,
                };
            }

            this.setState({
                current_bid: data.current_bid,
                current_pool: data.current_pool,
                current_group_number: data.current_group_number,
                last_group: data.last_group,
                next_groups: data.next_groups && data.next_groups.length > 2 ? data.next_groups.slice(0, 2) : data.next_groups,
                user: data.user,
                total_graph_data: total_graph_data,
            });
        }

        const subscriptionConfig = {
            subscription: graphql`
                subscription WMMobileTopSubscription($event_id: ID!, $quarter_id: ID!){
                    golfLeaderboardFindEventById(event_id: $event_id, quarter_id: $quarter_id){
                        event_id
                        quarter_id
                    }
                }
            `,
            variables: { event_id: event_id, quarter_id: quarter_id },
            onError: error => console.log("Subscription error : ", error),
            updater: store => {
                this.props.refetchData();
            },
        };
        this.subscription = requestSubscription(environment, subscriptionConfig);
    }

    componentDidUpdate(prevProps){
        if(prevProps.quarter_id != this.props.quarter_id) this._refetch();
    }

    componentWillUnmount(){
        this.subscription.dispose();
    }

    loadGraphs(){
        const { classes, quarter_id } = this.props;
        const { next_groups } = this.state;
        let jsx = [];

        function getData(group){
            let numbers = [];
            let labels = [];
            group.players.forEach(p => {
                numbers.push(p.percentage);
                labels.push(p.name);
            });
            let data = {
                labels: labels,
                datasets: [{
                    data: numbers,
                    backgroundColor: colors,
                    borderColor: colors,
                }]
            };
            return {group_data: data, labels: labels};
        }

        if(next_groups.length >= 2){
            const groups = next_groups.slice(0, 2);
            groups.forEach((next, i) => {
                let { group_data, labels } = getData(next);
                jsx.push(
                    <Grid item xs={6} key={`wm-mobile-ng-${i}`} style={{marginTop: '0.5em', marginBottom: '4em'}}>
                        <p className={classes.mediumTitle}>GROUP {next.group_number}</p>
                        <hr className={classes.wmHR} style={{marginBottom: '1em'}} />
                        <Doughnut
                            data={group_data} height={120} options={{legend: false}} key={`graph-${i}`}
                        />
                        <div style={{textAlign: 'center'}} key={`legend-div-${i}-${next.group_number}`}>
                    {
                        labels.map((label, j) => {
                            const names = label.split(" ");
                            const first = names[0];
                            const last = names[1];
                            return ([
                                <div className={classes.chartLegend} style={{background: colors[j]}} key={`legend-${i}${j}`} />,
                                <span className={classes.legendText} key={`legendText-${i}${j}`}>
                                    {`${first[0]}.${last}`}
                                </span>,
                                <br key={`label-br-${i}${j}`} />,
                            ])
                        })
                    }
                        </div>
                    </Grid>
                );
            })
        } else if(next_groups[0] && next_groups[0].group_number) {
            let { group_data, labels } = getData(next_groups[0]);
            jsx.push(
                <Grid item xs={12} key={`wm-mobile-ng-1`} style={{marginTop: '0.5em', marginBottom: '4em'}}>
                    <p className={classes.mediumTitle}>GROUP {next_groups[0].group_number}</p>
                    <hr className={classes.wmHR2} style={{marginBottom: '1em'}} />
                    <Doughnut
                        data={group_data} height={80} options={{legend: false}} key={`dn-graph`}
                    />
                    <div style={{textAlign: 'center'}}>
                    {
                        labels.map((label, j) => {
                            const names = label.split(" ");
                            const first = names[0];
                            const last = names[1];
                            return ([
                                <div className={classes.chartLegend} style={{background: colors[j]}} key={`legend-${j}`} />,
                                <span className={classes.legendText} key={`legendText-${j}`}>
                                    {`${first[0]}.${last}`}
                                </span>,
                                <br />,
                            ])
                        })
                    }
                    </div>
                </Grid>
            )
        } else {
            return (
                <Grid item xs={12} style={{height: quarter_id == -1 ? '50px' : '100px'}}>
                </Grid>
            )
        }

        return jsx;
    }

    render(){
        const { classes, event_token, quarter_id, page_number, changePage, landscape } = this.props;
        const { current_bid, current_pool, current_group_number, last_group, next_groups, user, total_graph_data } = this.state;
        let winning_players_text = [];
        if(last_group && last_group.winning_players) last_group.winning_players.forEach(pl => {
            const split_name = pl.split(" ");
            winning_players_text.push(`${split_name[0][0]}. ${split_name[1]}`);
        });
        const variables = { event_token: event_token, guest_token: ' ', quarter_id: quarter_id, page_number: page_number };

        return ([
            current_group_number?
            !next_groups.length && !last_group.guests ?
            <Grid item xs={12} key='chp-not-open' style={{paddingTop: '2em'}}>
                <p className={classes.noticeText}>Check Back Later</p>
            </Grid>
            :
            <>
            <Grid item xs={12} key='wm-mobile-1'>
                <p className={classes.largeTitle}>CURRENT POOL</p>
                <hr className={classes.wmHR} />
                <p className={classes.extralargeText}>${current_pool ? current_pool.toLocaleString() : 0}</p>
            </Grid>
            <Grid item xs={6} key='wm-mobile-2' style={{paddingLeft: '4.5em'}}>
                <p className={classes.smallTitle}>CURRENT GROUP</p>
                <hr className={classes.wmHR} />
                <p className={classes.largeText}>{current_group_number}</p>
            </Grid>
            <Grid item xs={6} key='wm-mobile-3' style={{paddingRight: '4.5em'}}>
                <p className={classes.smallTitle}>CURRENT BID</p>
                <hr className={classes.wmHR} />
                <p className={classes.largeText}>${current_bid}</p>
            </Grid>
            </> :
            quarter_id != -1 &&
            <Grid item xs={12} key='chp-ended' style={{paddingTop: '2em'}}>
                <p className={classes.noticeText}>Thanks For Playing!</p>
            </Grid>
            ,
            quarter_id != - 1 &&
            <Grid item xs={12} key='wm-mobile-4'>
                <p className={classes.mediumTitle}>LAST GROUP</p>
                <div className={classes.lastgroupDiv}>
                    <div className={classes.leftDiv}>
                        <div>
                            <p className={classes.groupTitle}>GROUP {last_group.group_number ? last_group.group_number : '-'}</p>
                            <p className={classes.groupText}>{winning_players_text.join(",")}</p>
                            <p className={classes.groupText}>${last_group.winning_money ? `${Math.floor(last_group.winning_money)}/ea` : 'N/A'}</p>
                        </div>
                    </div>
                    <div className={classes.rightDiv}>
                        <div>
                            {
                                last_group.guests && last_group.guests.map((guest, i) => {
                                    return (
                                        <span key={`guest-${i}`}>{guest}</span>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </Grid>,
            this.loadGraphs(),
            <div key='wm-mobile-leaderboard' className={classes.wmLeaderboardDiv}>
                <WMMobileLeadContainer
                    changePage={changePage}
                    page_number={page_number}
                    user={user}
                    event_token={event_token}
                    quarter_id={quarter_id}
                    landscape={landscape}
                />
            </div>,
            quarter_id == -1 &&
            <div style={{width: '90%', height: '600px', marginTop: '4em'}} key='total-graph'>
                <Bar
                    data={total_graph_data}
                    options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        legend: {
                            display: false
                        },
                        scales: {
                            xAxes: [{
                                stacked: true,
                                ticks: {
                                    fontColor: 'white',
                                    fontSize: 18,
                                    fontFamily: 'Maax-Bold',
                                },
                                gridLines: {
                                    color: 'rgba(0, 0, 0, 0)',
                                    zeroLineColor: 'transparent',
                                    zeroLineWidth: 0,
                                },
                                gridLines: {
                                    color: 'rgba(0, 0, 0, 0)',
                                    zeroLineColor: 'white',
                                    zeroLineWidth: 3,
                                },
                            }],
                            yAxes: [{
                                stacked: false,
                                scaleLabel:{
                                    display: false,
                                },
                                ticks: {
                                    display: false,
                                },
                                gridLines: {
                                    display: false,
                                },
                            }]
                        },
                    }}
                />
            </div>,
            <Grid item xs={12} style={{height: quarter_id == -1 ? '50px' : '150px'}} key='wm-mobile-em'>
            </Grid>
        ])
    }
}

export default createRefetchContainer(
    withStyles(useStyles)(WMMobileTop),
    {
        getLonewolfPersonalData: graphql`
            fragment WMMobileTop_getLonewolfPersonalData on Query
                @argumentDefinitions(
                    event_token: { type: "String!" }
                    guest_token: { type: "String!" }
                    quarter_id: { type: "Int!" }
                ){
                    getLonewolfPersonalData(event_token: $event_token, guest_token: $guest_token, quarter_id: $quarter_id){
                        data {
                            user {
                                name
                                points
                                position
                            }
                            current_group_number
                            current_bid
                            current_pool
                            last_group {
                                group_number
                                guests
                                winning_players
                                winning_money
                            }
                            winnings_by_group {
                                group_number
                                money
                                user_won
                            }
                            next_groups {
                                group_number
                                players {
                                    name
                                    percentage
                                    picked
                                }
                            }
                            total_page
                            cumulative_total_page
                        }
                    }
                }
        `
    },
    graphql`
        query WMMobileTopRefetchQuery($event_token: String!, $guest_token: String!, $quarter_id: Int!){
            ...WMMobileTop_getLonewolfPersonalData @arguments(event_token: $event_token, guest_token: $guest_token, quarter_id: $quarter_id)
        }
    `
)